const $window = $(window);
const $header = $('.site-header');
const $footer = $('.site-footer');
const $homeSlideshow = $('.home-slideshow');
let timeout;

function fixHeight() {
    $homeSlideshow.height($window.height() - $header.outerHeight());
}

if ($homeSlideshow.length) {
    $window.on('resize', () => {
        clearTimeout(timeout);
        timeout = setTimeout(fixHeight, 300);
    });

    fixHeight();

    $homeSlideshow.slick({
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
        useCSS: true,
        useTransform: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        dots: true,
        pauseOnDotsHover: true,
        customPaging: () => ''
    });
}



// WEBPACK FOOTER //
// ./scripts/home.js